import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { ChevronRight, BookOpen, ArrowLeft } from "lucide-react";

export default function SubjectDetail() {
  const { subjectKey } = useParams();
  const [subject, setSubject] = useState(null);

  useEffect(() => {
    api.get(`/curriculum/subjects/${subjectKey}`).then((r) => setSubject(r.data));
  }, [subjectKey]);

  if (!subject) return <div className="text-slate-500">Yükleniyor…</div>;

  return (
    <div className="space-y-5 ela-fade-in" data-testid="subject-detail-page">
      <Link to="/dersler" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-slate-900">
        <ArrowLeft className="w-4 h-4" /> Tüm dersler
      </Link>
      <div>
        <h1 className="font-heading text-3xl font-bold text-slate-900">{subject.name}</h1>
        <p className="text-slate-500 text-sm mt-1">{subject.units.length} ünite</p>
      </div>

      <Card className="rounded-2xl border-slate-200">
        <Accordion type="multiple" defaultValue={[subject.units[0]?.code]}>
          {subject.units.map((u) => (
            <AccordionItem key={u.code} value={u.code} className="border-b border-slate-100 last:border-b-0 px-4">
              <AccordionTrigger className="hover:no-underline py-4" data-testid={`unit-${u.code}`}>
                <div className="flex items-center gap-3 text-left">
                  <div className="w-9 h-9 rounded-xl bg-slate-100 flex items-center justify-center">
                    <BookOpen className="w-4 h-4 text-slate-600" />
                  </div>
                  <div>
                    <div className="font-heading font-semibold text-slate-900">{u.name}</div>
                    <div className="text-xs text-slate-500">{u.topics.length} konu · {u.code}</div>
                  </div>
                </div>
              </AccordionTrigger>
              <AccordionContent className="pb-4 pl-12 pr-2">
                <div className="space-y-1.5">
                  {u.topics.map((t) => (
                    <Link key={t.code}
                      to={`/konu/${subjectKey}/${t.code}`}
                      data-testid={`topic-link-${t.code}`}
                      className="flex items-center justify-between p-3 rounded-lg hover:bg-slate-50 border border-transparent hover:border-slate-200 transition">
                      <div className="min-w-0">
                        <div className="text-sm font-medium text-slate-900 truncate">{t.name}</div>
                        <div className="text-[11px] text-slate-500 line-clamp-1">{t.kazanim}</div>
                      </div>
                      <ChevronRight className="w-4 h-4 text-slate-400 shrink-0" />
                    </Link>
                  ))}
                </div>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Card>
    </div>
  );
}
